<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="px-12">
              <v-img contain :src="image" />
            </v-col>
            <v-col class="my-auto">
              <div class="text-h4 font-weight-bold mb-2">
                {{ annualreview.annualReviewStartDate | year }} Annual Review:
                <span class="performance--text">{{ title }}</span>
              </div>
              <div class="subtitle-1">
                {{ text }}
              </div>
              <div>
                <v-stepper v-model="step" class="transparent mr-12">
                  <v-stepper-header>
                    <v-stepper-step
                      :complete="step > 1"
                      step="1"
                      color="performance"
                      class="subtitle-1 pl-0"
                    >
                      CoreBoard
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      :complete="step > 2"
                      step="2"
                      color="performance"
                      class="subtitle-1"
                    >
                      Q&A Review
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                      step="3"
                      :color="
                        annualreview.userSignoffDate != null &&
                        annualreview.managerSignoffDate != null
                          ? 'success'
                          : 'performance'
                      "
                      class="subtitle-1"
                      :complete="
                        annualreview.userSignoffDate != null &&
                          annualreview.managerSignoffDate != null
                      "
                    >
                      Sign Off
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewTopCard",
  props: { tab: { type: Number } },
  computed: {
    step() {
      return this.tab + 1;
    },
    title() {
      switch (this.tab) {
        case 0:
          return "CoreBoard";
        case 1:
          return "Q&A Review";
        case 2:
          return "Sign Off";
        default:
          return "";
      }
    },
    image() {
      switch (this.tab) {
        case 0:
          return this.$images.ANNUAL_REVIEW_COREBOARD;
        case 1:
          return this.$images.ANNUAL_REVIEW_QA;
        case 2:
          return this.$images.ANNUAL_REVIEW_CHEERS;
        default:
          return "";
      }
    },
    text() {
      switch (this.tab) {
        case 0:
          return `Let's start this annual review by diving into
                ${this.annualreview.user.firstName}'s performance. On this page
                you'll find our CoreBoard for
                ${this.annualreview.user.firstName} that shows the data we've
                collected.`;
        case 1:
          return `${this.profile.companyName} has prepared this list of questions for you to complete. Your honest feedback is greatly appreciated!`;
        case 2:
          return `The sign off portion of this review is the last step before this annual review is marked complete. We suggest you meet prior to signing off.`;
        default:
          return "";
      }
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      profile: "profile/profile"
    })
  }
};
</script>

<style lang="scss" scoped>
.v-stepper__step:not(.v-stepper__step--inactive) {
  ::v-deep .v-stepper__label {
    color: var(--v-performance-base) !important;
  }
}

.v-stepper__header {
  hr {
    border-top-style: dashed;
  }
}
</style>
